/** Users see the assistant only when their account carries this tag (from /me). */
export const ASSISTANT_FEATURE_TAG = 'feature:assistant';

export const isAssistantEnabled = (
  user?: { tags?: ReadonlyArray<string> | null } | null
): boolean => Boolean(user?.tags?.includes(ASSISTANT_FEATURE_TAG));
